;$(function () {
  'use strict'

  const $slimCommentPanel = $('[data-slim-comment-panel]')
  const $slimCommentInput = $('[data-slim-comment-input]')
  const $commentEditor = $('[data-blogs-new-comment-form]').find('[data-blog-editor]')

  $(window).on('scroll', function () {
    if ($('.blogpost-page__comment_new').is(':in-viewport')) {
      $slimCommentPanel.addClass('layout__none')
    }
    else {
      $slimCommentPanel.removeClass('layout__none')
      $(document).trigger('Blogs::showPanel')
    }
  })

  $slimCommentInput.on('click', function () {
    $('html').animate(
      {
        scrollTop: $commentEditor.offset().top - 120
      },
      'slow',
      function () {
        $commentEditor.focus()
      }
    )
  })
})
